import { render } from "./DashboardTransactions.vue?vue&type=template&id=f5e8f280"
import script from "./DashboardTransactions.vue?vue&type=script&lang=js"
export * from "./DashboardTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script